import React, { Suspense } from 'react';
import dynamic from 'next/dynamic';

import { Skeleton, Stack } from '@lyearn/ui';
import { NavConfigFragment } from '@/components/ConfigsProvider/graphql/fragment/generated/NavConfig';
import { FeatureFlags, useFeatureFlags } from '@/helper/FeatureFlags';

const DefaultRightNodeDynamic = dynamic(
  () => import(/* webpackPreload: true */ /* webpackChunkName: "header-default-right-node" */ './'),
);

const DefaultRightNodeDynamicLegacy = dynamic(
  () =>
    import(
      /* webpackPreload: true */ /* webpackChunkName: "header-default-right-node-legacy" */ './legacy.index'
    ),
);

const Loader = ({ isUnifiedDashboardEnabled }: { isUnifiedDashboardEnabled: boolean }) => {
  return (
    <Stack className="space-s-12">
      {!isUnifiedDashboardEnabled && (
        <Skeleton
          animation="wave"
          className="absolute top-14 flex -translate-x-1/2 transform rounded-4 opacity-60 start-1/2 rtl:translate-x-1/2 xs:hidden"
          height={32}
          variant="rectangular"
          width="35%"
        />
      )}
      {Array.from({ length: 3 }).map((_, num) => (
        <Skeleton
          key={num}
          animation="wave"
          className="rounded-4 opacity-60"
          height={32}
          variant="rectangular"
          width={32}
        />
      ))}
      <Skeleton animation="wave" className="opacity-60" height={32} variant="circular" width={32} />
    </Stack>
  );
};

const DefaultRightNodeLazy = ({
  previewNavConfig,
}: {
  previewNavConfig?: NavConfigFragment | undefined;
}) => {
  const { [FeatureFlags.EnableUnifiedDashboard]: isUnifiedDashboardEnabled } = useFeatureFlags();

  return (
    <Suspense fallback={<Loader isUnifiedDashboardEnabled={isUnifiedDashboardEnabled} />}>
      {isUnifiedDashboardEnabled ? (
        <DefaultRightNodeDynamic previewNavConfig={previewNavConfig} />
      ) : (
        <DefaultRightNodeDynamicLegacy previewNavConfig={previewNavConfig} />
      )}
    </Suspense>
  );
};

export default DefaultRightNodeLazy;
